<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

@if (podeAcessarComponenteSelecionado()) {
    <!-- Lateral na medida única do projeto (`.layout-com-lateral`); sem card, o conteúdo ocupa tudo. -->
    <div [class.layout-com-lateral]="isMedicoSelecionado() && !isFerramentaSelecionada()" class="w-full">
        @if (isMedicoSelecionado() && !isFerramentaSelecionada()) {
            <div class="pb-5 min-w-0">
                <app-pessoa-detalhe #pessoaDetalhe [pessoa]="pessoa()" [exibirRecuperabilidade]="false"></app-pessoa-detalhe>
            </div>
        }
        <div class="w-full min-w-0">
            <div class="grid-debitos grow">
                @if (selectedComponent() === 'visto-temporario-localizar' || selectedComponent() === 'visto-temporario-novo') {
                    <div class="content">
                        @if (mostrarGerenciarVisto) {
                            <app-gerenciar-visto [pessoa]="pessoa()" [acaoSelecionada]="vistoAcaoSelecionada ?? 'LOCALIZAR'" [dadosNovoVisto]="novoVistoSolicitacao" [dadosLocalizarVisto]="dadosLocalizarVisto" (voltar)="voltarParaOpcoesVisto()">
                            </app-gerenciar-visto>
                        } @else if (selectedComponent() === 'visto-temporario-localizar') {
                            <app-localizar-visto [pessoa]="pessoa()" (confirmar)="confirmarLocalizacaoVisto($event)" (cancelar)="cancelarLocalizacaoVisto()"></app-localizar-visto>
                        } @else {
                            <app-novo-visto (gerarSolicitacao)="confirmarNovoVistoSolicitacao($event)" (cancelar)="cancelarNovoVistoSolicitacao()"></app-novo-visto>
                        }
                    </div>
                } @else if (selectedComponent() === 'central-transferencias-solicitar') {
                    <app-solicitar-transferencia (selecionarRegistro)="showPesquisarPessoa()"></app-solicitar-transferencia>
                } @else if (selectedComponent() === 'central-transferencias' || selectedComponent() === 'central-transferencias-abertas-uf-origem') {
                    <app-abertas-uf-origem></app-abertas-uf-origem>
                } @else if (selectedComponent() === 'central-transferencias-abertas-uf-destino') {
                    <app-abertas-uf-destino></app-abertas-uf-destino>
                } @else if (selectedComponent() === 'central-transferencias-aguardando-encerramento') {
                    <app-aguardando-encerramento></app-aguardando-encerramento>
                } @else if (selectedComponent() === 'contatos') {
                    <div class="content w-full">
                        <app-contato [pessoa]="pessoa()" [roleEditarContato]="PERMISSOES.medicos.contato.editar" [roleExcluirContato]="PERMISSOES.medicos.contato.excluir"></app-contato>
                    </div>
                } @else if (selectedComponent() === '') {
                    <!-- Sentinela: raiz sem slug e sem permissão para o default (dados-registro). Orienta a
                         escolher uma aba pelo menu (em vez de card vazio) e oferece pesquisar outro registro. -->
                    <app-empty
                        [titulo]="'Selecione uma funcionalidade'"
                        [descricao]="'Utilize o menu ao lado para escolher uma das opções disponíveis para este registro.'"
                        [labelBotao]="'Pesquisar Pessoa'"
                        [iconBotao]="'pi pi-search'"
                        [acao]="showPesquisarPessoa"
                    ></app-empty>
                } @else {
                    <p-card class="w-full">
                        <div class="content">
                            @switch (selectedComponent()) {
                                @case ('dados-registro') {
                                    <app-dados-registro #dadosRegistroRef [pessoa]="pessoa()" (salvar)="onSalvarDadosRegistro($event)"></app-dados-registro>
                                }
                                @case ('biometria') {
                                    <app-biometria [pessoa]="pessoa()" (salvo)="onBiometriaSalva()"></app-biometria>
                                }
                                @case ('documentos') {
                                    <app-documentos #documentosRef [pessoa]="pessoa()" (salvar)="onSalvarDocumentos($event)"></app-documentos>
                                }
                                @case ('documentos-emissao') {
                                    <app-documentos-medico></app-documentos-medico>
                                }
                                @case ('formacao') {
                                    @if (!formacaoDetailData) {
                                        <app-formacao-lista [pessoa]="pessoa()" (rowClick)="onFormacaoRowClick($event)" (novoClick)="onFormacaoNovo($event)"></app-formacao-lista>
                                    } @else {
                                        <app-formacao [(modoEdicao)]="modoEdicao" [pessoa]="pessoa()" [selectedDetail]="formacaoDetailData" (voltar)="onFormacaoVoltar()"></app-formacao>
                                    }
                                }
                                @case ('especialidade') {
                                    <app-especialidade-container [pessoa]="pessoa()"></app-especialidade-container>
                                }
                                @case ('historico') {
                                    <app-historico [pessoa]="pessoa()"></app-historico>
                                }
                                @case ('funcoes') {
                                    <app-funcoes [pessoa]="pessoa()"></app-funcoes>
                                }
                                @case ('anotacoes') {
                                    <app-anotacoes [pessoa]="pessoa()" [roleCriar]="PERMISSOES.medicos.anotacoes.criar" [roleExcluir]="PERMISSOES.medicos.anotacoes.excluir"></app-anotacoes>
                                }
                                @case ('consultorio-privado') {
                                    <app-dashboard-consultorio [pessoa]="pessoa()"></app-dashboard-consultorio>
                                }
                                @case ('telemedicina') {
                                    <app-telemedicina [pessoa]="pessoa()"></app-telemedicina>
                                }
                                @case ('pcmso') {
                                    <app-pcmso [pessoa]="pessoa()"></app-pcmso>
                                }
                                @case ('conflito-interesse') {
                                    <app-conflito-interesse [pessoa]="pessoa()"></app-conflito-interesse>
                                }
                                @case ('central-transferencias-localizar-cpf') {
                                    <app-localizar-por-cpf></app-localizar-por-cpf>
                                }
                            }
                        </div>
                    </p-card>
                }
            </div>
        </div>
    </div>
} @else {
    <app-empty [titulo]="'Registro não selecionado'" [descricao]="'Por favor, selecione um registro para visualizar os dados'" [acao]="showPesquisarPessoa" [iconBotao]="'pi pi-search'" [labelBotao]="'Selecionar Registro'"></app-empty>
}
